module.exports = __webpack_public_path__ + "img/9.7.Chla.ab65bf9b.png";